<script>
import { get, keys, set } from "lodash";
import EmptyDetailCard from "@/components/dashboard/profile-detail/EmptyDetailCard";
import { mapActions } from 'vuex';

export default {
  name: "simple-diversity",
  components: {
    EmptyDetailCard,
  },
  data: () => ({
    value: {
      gender: { field: "Gênero", value: null },
      breed: { field: "Cor", value: null },
      deficiency: { field: "Deficiência(s)", value: null },
      isEgression: { field: "Pessoa egressa ou pré-egressa", value: null },
      isReability: { field: "Pessoa com deficiência reabilitada pelo INSS", value: null },
    },
  }),
  computed: {
    color() {
      return get(this.$store, 'state.company.base_hexcolor', '#0984e3');
    },
  },
  methods: {
    ...mapActions('step', ['updateCurrentStep']),
    navigateToSelectedStep() {
      this.updateCurrentStep({ order: 2 })
      this.$router.push({ name: 'step-diversity' })
    },
    show() {
      return keys(this.value).filter((key) => this.value[key].value !== null).length > 0;
    },
    fetchDiversityOptionsRequest() {
      this.$vs.loading();

      this.$http
        .get("/api/v1/diversity?debug=true")
        .then((response) => {
          const { data = [] } = response;

          const breeds = get(data, "breeds", []);
          const genders = get(data, "genders", []);

          const breedValue =
            breeds.find((breed) => breed.id === this.$store.state.diversity.breed.id)
              .name || "Não informado";
          const genderValue =
            genders.find(({ id }) => id == this.$store.state.diversity.gender).name ||
            "Não informado";
          
          const deficiencies = get(this.$store, 'state.diversity.deficiencies', []);

          let deficiencyValue = "Não informado";

          if (deficiencies !== null) {
            deficiencyValue = deficiencies.map((deficiency) => deficiency.name).join(", ");
          }
          
          const isEgressionValue = this.$store.state.diversity.is_egression
            ? "Sim"
            : "Não";
          const pcdReabilityValue = this.$store.state.diversity.pcd_reability
            ? "Sim"
            : "Não";

          set(this.value, "gender.value", genderValue);
          set(this.value, "breed.value", breedValue);
          set(this.value, "deficiency.value", deficiencyValue);
          set(this.value, "isReability.value", pcdReabilityValue);
          set(this.value, "isEgression.value", isEgressionValue);

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    this.fetchDiversityOptionsRequest();
  },
};
</script>

<template>
  <div class="flex flex-col py-4 bg-white mb-4">
    <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
      <div class="flex">
        <feather-icon
          class="mr-2"
          icon="UsersIcon"
          svgClasses="text-black stroke-current w-36.96 h-36.96"
        ></feather-icon>
        <h4>Diversidade</h4>
      </div>

      <vs-button
        class="ml-2 mobile-hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      >
        Editar
      </vs-button>

      <vs-button
        class="ml-2 sm:hidden"
        size="small"
        color="primary"
        type="border"
        icon="edit"
        @click="navigateToSelectedStep"
      />
    </vs-col>

    <hr class="my-4 line" />

    <div class="flex">
      <div v-if="show()" class="flex flex-col">
        <ul class="activity-timeline mobile-hidden">
          <li>
            <div
              class="timeline-icon"
              :style="{ backgroundColor: color }"
              key="timeline-basicInfo"
            >
              <feather-icon
                icon="UsersIcon"
                svgClasses="text-white stroke-current w-5 h-5"
              />
            </div>
            <div class="flex pl-1 my-1" v-for="key in Object.keys(value)" :key="key">
              <p v-if="value[key].value !== null">
                <b>{{ value[key].field }}:</b> {{ value[key].value }}
              </p>
            </div>
          </li>
        </ul>
        <div class="sm:hidden">
          <div class="flex pl-1 my-1" v-for="key in Object.keys(value)" :key="key">
            <p v-if="value[key].value !== null">
              <b>{{ value[key].field }}:</b> {{ value[key].value }}
            </p>
          </div>
        </div>
      </div>
      <div v-else class="empty__container">
        <EmptyDetailCard
          description="Você ainda não preencheu nenhuma informação sobre diversidade."
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";

hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}

.empty__container {
  margin: 0 auto;
}
</style>
